import { useMutation as h } from "@tanstack/react-query";
import { useAuthStore as S, authService as m, setSubscriptionPlan as c, updateAuthState as p } from "@waitroom/auth";
import { activateTrialMutation as w, getRequestData as l } from "@waitroom/react-query";
const T = async (t, r, a, e) => {
  const o = l(t);
  if (!o) throw new Error("Something went wrong");
  const { authToken: n, refreshToken: u, userSubscriptionPlan: s } = o;
  if (n) {
    const f = {
      accessToken: n,
      refreshToken: u
    }, i = await m.setup(f);
    if (!i.isAuthenticated) throw new Error("Unauthorized");
    s && c(s), i && p(i);
  } else
    s && c(s);
  e && e(t, r, a);
}, g = (t) => {
  const { userId: r, accessToken: a } = S();
  return h({
    ...t,
    ...w({
      userId: r,
      accessToken: a
    }),
    onSuccess: (e, o, n) => T(e, o, n, t.onSuccess)
  });
};
export {
  g as useActivateTrial
};
